import { useCallback, useState } from "react";

/**
 * Tiny toast hook used across admin pages.
 *  const { toast, showToast, ToastView } = useToast();
 *  // ...
 *  showToast("ok", "Deleted!");
 *  // place <ToastView /> at the bottom of your page render.
 */
export default function useToast(defaultMs = 3500) {
  const [toast, setToast] = useState(null); // { kind, msg }

  const showToast = useCallback(
    (kind, msg, ms = defaultMs) => {
      setToast({ kind, msg });
      window.setTimeout(() => setToast(null), ms);
    },
    [defaultMs]
  );

  const ToastView = () => {
    if (!toast) return null;
    const cls =
      toast.kind === "ok"
        ? "bg-[#141e32] border-[#9bd17a] text-[#9bd17a]"
        : "bg-[#141e32] border-[#af3fa6] text-[#af3fa6]";
    return (
      <div
        className={`fixed bottom-6 right-6 z-50 px-5 py-4 rounded-xl border shadow-2xl max-w-sm ${cls}`}
        data-testid="admin-toast"
      >
        {toast.msg}
      </div>
    );
  };

  return { toast, showToast, ToastView };
}
